import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/transferInfo', request)
}

export {get}
